import {
    GET_CONFIG_FORM,
    GET_INSTANCIAS_EVENTO,
    GET_EVENTOS_BITACORA,
    GET_TIPOS_EVENTO,
    POST_REGISTRAR_BITACORA,
    CLEAR_CASOS_BANDEJA
} from '../types';


export default function encargadoCompaniaReducer(state = {}, action) {
    switch (action.type) {
        case GET_CONFIG_FORM:
            return { ...state, ...action.payload }
        case GET_INSTANCIAS_EVENTO:
            return { ...state, instancias: action.payload }
        case GET_TIPOS_EVENTO:
            return { ...state, tiposEvento: action.payload }
        case GET_EVENTOS_BITACORA:
            return { ...state, bitacora: action.payload }
        case POST_REGISTRAR_BITACORA:
            return { ...state, bitacoraRegistrada: action.payload }
        default:
            return state
    }
}